import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

import { Frame, PaymentScheduleItem, PaymentScheduleItemProps, PaymentScheduleTitle } from '../../../../../components'

export interface PaymentScheduleProps {
  readonly payments: readonly PaymentScheduleItemProps[]
  readonly title?: string
}

export const PaymentSchedule = (props: React.PropsWithChildren<PaymentScheduleProps>) => (
  <PaymentScheduleContainer>
    {props.title && <PaymentScheduleTitle title={props.title} />}
    {props.payments.map((payment, index) => payment && <PaymentScheduleItem key={`payment-${index}`} {...payment} />)}
    {props.children && <CenteredChildBox>{props.children}</CenteredChildBox>}
  </PaymentScheduleContainer>
)

const CenteredChildBox = styled(Box)`
  width: 100%;
`

const PaymentScheduleContainer = styled(Frame)`
  min-height: ${({ theme }) => theme.fixedSizes.spacing_400};
`
